import $ from "jquery";
import { forms } from "../framework/forms";
let editing = false;

function init() {
    editing = false;
    setEvents();
    setFieldsToDisabled();
    $("#attestationagree-acknowledgebutton").addClass("hidden");
}

function setEvents() {
    $("#editattestationsubmitbtn").on("click", editattestationsubmitbtnclick);
    $("#btnAttestationEdit").on("click", toggleEditing);
    $("#editAttestationIsGlobalYes").on("change", editAttestationIsGlobalYesChange);
    $("#editAttestationIsGlobalNo").on("change", editAttestationIsGlobalNoChange);
}

function editAttestationIsGlobalYesChange() {
    $("#EditAttestationProgramSelect").attr("disabled", true);
    $("#EditAttestationProgramSelect").val("");
}

function editAttestationIsGlobalNoChange() {
    $("#EditAttestationProgramSelect").attr("disabled", false);
}

function setFieldsToDisabled() {
    $(".edit-js").attr("disabled", "disabled");
}

function toggleEditing() {
    if (!editing) {
        editing = true;
        $(".edit-js").attr("disabled", false);
        $("#editIcon")
            .removeClass("fa-pen")
            .addClass("fa-times");
    } else {
        editing = false;
        setFieldsToDisabled();
        $("#editIcon")
            .removeClass("fa-times")
            .addClass("fa-pen");
    }
}

function editattestationsubmitbtnclick() {
    const $form = $(this).closest("form");
    if ($form.valid()) {
        forms.disableSubmitButton();
        $form.submit();
    }
}

export const editAttestation = {
    init: init
};